import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { DispatchStatePhase } from 'src/app/core/interfaces/dispatchStatePhase';
import { ParamsCargoList } from 'src/app/core/interfaces/paramsCargoList';
import { CargoService } from 'src/app/core/services/cargo.service';
import { Utils } from 'src/app/core/resources/utils';
import { Destination } from 'src/app/core/interfaces/destination';
import { CompanyNamePipe } from 'src/app/core/pipe/companyName.pipe';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Endpoints } from 'src/app/core/resources/endpoints';
import { Fmt } from 'src/app/core/messages/fmt';
import { ResponseList } from 'src/app/core/interfaces/response-list';
@Injectable()
export class PanelAssignmentService {
  constructor(
    private readonly http: HttpClient,
    private readonly endpoints: Endpoints,
    private readonly cargoService: CargoService,
    private readonly utils: Utils,
    private readonly companyNamePipe: CompanyNamePipe
  ) { }

  public getListDispatchStates(): Observable<DispatchStatePhase[]> {
    return this.http.get<DispatchStatePhase[]>(
      `${environment.urlServerTeclogi}${this.endpoints.cargoDispatchStates}`
    );
  }

  public getDispatchStates(): Observable<DispatchStatePhase[]> {
    return this.getListDispatchStates().pipe(
      map((states) => {
        const availableStates = new Map<string, DispatchStatePhase>();
        (states || [])
          .filter((state) => !!state && state.active)
          .sort((currentState, nextState) => currentState.order - nextState.order)
          .forEach((state) => {
            if (!availableStates.has(state.name))
              availableStates.set(state.name, state);
          });
        return Array.from(availableStates.values());
      })
    );
  }

  public updateDispatchState(cargoId: string, state: string, observations: string): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${environment.urlServerTeclogi}${Fmt.string(this.endpoints.updateDispatchState, cargoId)}`,
      { state, observations }
    );
  }

  public getServices(filters: Object): Observable<ResponseList<Cargo>> {
    return this.cargoService.cargoList(filters as ParamsCargoList);
  }
}
